import { Button } from '@spark-web/button';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useOutletContext } from 'react-router';

import { CHANNEL_TO_FINANCIAL_PRODUCT_ID, PARTNER_TO_CHANNEL } from '~/constants';
import { CustomerFormValues, OutletContextType } from '~/types/marketplace';

import { Alert } from '../common/alert';

import { CustomerFormField } from './components/customer-form-field';

export type RequestQuoteFormProps = {
  onSubmit: (data: Partial<CustomerFormValues>) => void;
  isLoading: boolean;
  error: Record<string, string> | string | undefined;
  leadType?: 'Marketplace' | 'Concierge';
  excludedFields?: (keyof CustomerFormValues)[];
};

export const RequestQuoteForm = ({
  onSubmit,
  isLoading: isSubmitting,
  error,
  leadType = 'Concierge',
  excludedFields,
}: RequestQuoteFormProps) => {
  const { partner } = useOutletContext<OutletContextType>();

  const channel = partner && PARTNER_TO_CHANNEL(partner);
  const channelFinancialProductId = channel && CHANNEL_TO_FINANCIAL_PRODUCT_ID[channel];

  const formProvider = useFormContext();

  const [isValidating, setIsValidating] = useState(false);
  const isLoading = isSubmitting || isValidating;

  const onCustomerFormFieldValidating = (isValidating: boolean) => {
    setIsValidating(isValidating);
  };

  const {
    handleSubmit,
    register,
    formState: { isValid },
  } = formProvider;

  return (
    <Stack gap="xlarge">
      <Stack paddingBottom="large">
        <Text size="large" weight="semibold">{`Let's connect you with Brighte vendors`}</Text>
      </Stack>
      <CustomerFormField
        leadType={leadType}
        excludedFields={excludedFields}
        onPartnerCustomerIdValidating={onCustomerFormFieldValidating}
      />
      <input type="hidden" value={partner} {...register('partner')} />
      <input type="hidden" value={channelFinancialProductId} {...register('financialProductId')} />
      {error && !isLoading ? <Alert error="REQUEST_ERROR" /> : null}
      <Stack gap="xxlarge" marginTop="medium">
        <Button disabled={!isValid} loading={isLoading} onClick={handleSubmit(onSubmit)}>
          Send quote requests
        </Button>
      </Stack>
    </Stack>
  );
};
